import BaseItemInterface from 'interfaces/base-item.interface';
import BannerInterface from 'modules/shared/layout/menu/components/menu-banner/banner.interface';

export default interface MenuInterface {
    id: number;
    n: string;
    img?: string | null;
    i?: string | null;
    url: string;
    r?: BaseItemInterface[];
    b?: BannerInterface[];
    itm?: MenuInterface[];
}

export enum MenuKeys {
    name = 'n',
    image = 'img',
    icon = 'i',
    recommended = 'r',
    banner = 'b',
    items = 'itm'
}
